module.exports = function () {
    return function (deliverySaverPlan = {}) {
        if (deliverySaverPlan.IsAnyDay) {
            return 'Delivery Unlimited Any Day';
        } else if (deliverySaverPlan.IsMidweek) {
            return 'Delivery Unlimited Midweek';
        }
        return 'Delivery Unlimited';
    };
};



// WEBPACK FOOTER //
// ./src/deliverysaver/delivery-saver-type-name.filter.js